import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './i18n';
import './index.css';

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!clientId) {
  throw new Error(
    'Google OAuth Client ID not found. Please set REACT_APP_GOOGLE_CLIENT_ID in your environment variables.',
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <GoogleOAuthProvider clientId={clientId}>
    <BrowserRouter>
          <App />
    </BrowserRouter>
    </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
